let bestPracticesData = [
	{
		id: 15,
		title: {
			en: 'Safety survey',
			de: 'Sicherheitsumfrage',
			pt: 'Pesquisa de segurança'
		},
		textFront: {
			en: 'The company conducts a Safety Survey in the form of an anonymous questionnaire, where the employees can highlight the dirty dozen commonly experienced, diversions from safe practices and operational challenges.',
			de: 'Das Unternehmen führt eine Sicherheitsumfrage in Form eines anonymen Fragebogens durch, in dem die Mitarbeiter die am häufigsten vorkommenden Dirty Dozen und betriebliche Herausforderungen aufzeigen können.',
			pt: `A empresa realiza uma Pesquisa de Segurança na forma de um questionário anônimo, onde os funcionários podem destacar os doze problemas mais comuns, desvios das práticas de segurança e desafios operacionais.`
		},
		textBack: {
			en: 'The survey allows the company to focus their efforts into the areas where most needed. This will reduce the overall risk by focusing on the effectiveness of the barriers against errors.',
			de: 'Die Umfrage ermöglicht es dem Unternehmen, seine Anstrengungen auf die Bereiche zu konzentrieren, in denen sie am dringendsten benötigt werden. Indem der Schwerpunkt auf das Verhindern von Fehlern gelegt wird, kann das Gesamtrisiko gesenkt werdern.',
			pt: `A pesquisa permite que a empresa concentre os seus esforços nas áreas onde são mais necessários. Isso reduzirá o risco geral, focando-se na eficácia das barreiras contra erros.`
		},
		effects: [
			{type: 'risk', value: -2}
		],
		scenarioIds: ['default', 'light-one']
	},
	{
		id: 16,
		title: {
			en: 'Tool box meetings',
			de: 'Toolbox-Meeting',
			pt: 'Reuniões de segurança'
		},
		textFront: {
			en: 'The company introduces short, informal, tool box meetings at least once a day.',
			de: 'Das Unternehmen führt mindestens einmal täglich kurze, informelle Toolbox-Meetings ein.',
			pt: `A empresa implementou reuniões curtas e informais de segurança pelo menos uma vez por dia.`
		},
		textBack: {
			en: 'Regular meetings elevate the general situational awareness, increases the feeling of teamwork and allows for knowledge sharing.',
			de: 'Regelmäßige Treffen erhöhen das allgemeine Situationsbewusstsein, steigern das Gefühl der Teamarbeit und ermöglichen den Wissensaustausch.',
			pt: `Reuniões regulares aumentam a consciência situacional geral, fortalecem o espírito de equipe e permitem a partilha de conhecimento.`
		},
		effects: [
			{type: 'time', value: -1},
			{type: 'risk', value: -1}
		],
		scenarioIds: ['default', 'light-two']
	},
	{
		id: 17,
		title: {
			en: 'Technical training',
			de: 'Technisches Training',
			pt: 'Formação técnica'
		},
		textFront: {
			en: 'The company conducts recurrent technical training.',
			de: 'Das Unternehmen führt regelmäßig technische Schulungen durch.',
			pt: `A empresa realiza treinos técnicos recorrentes.`
		},
		textBack: {
			en: 'The knowledge of the staff increases, giving improved system knowledge and troubleshooting skills.',
			de: 'Der Wissensstand der Mitarbeiter erhöht sich, was zu besseren Systemkenntnissen und Fähigkeiten zur Fehlersuche führt.',
			pt: `O conhecimento da equipa aumenta, proporcionando melhor conhecimento do sistema e mais capacidades de resolução de problemas.`
		},
		effects: [
			{type: 'risk', value: -1},
			{type: 'cost', value: -1}
		],
		scenarioIds: ['default', 'light-one']
	},
	{
		id: 18,
		title: {
			en: 'Minimum stock list',
			de: 'Mindestbestandsliste',
			pt: `Lista de stock mínimo`
		},
		textFront: {
			en: 'The company asks the employees for their input to a “minimum stock” list of items that are repeatedly found out of stock.',
			de: 'Das Unternehmen bittet die Mitarbeiter, Artikel, die wiederholt nicht vorrätig sind, in eine "Mindestbestandsliste" einzutragen..',
			pt: `A empresa solicita aos funcionários que contribuam com uma lista de "stock mínimo" de itens que estão frequentemente em falta.`
		},
		textBack: {
			en: 'A full stock list reduces interruptions in the workflow.',
			de: 'Eine vollständige Bestandsliste verringert Unterbrechungen im Arbeitsablauf.',
			pt: `Uma lista completa de stock reduz as interrupções no fluxo de trabalho.`
		},
		effects: [
			{type: 'risk', value: -1},
			{type: 'time', value: -1}
		],
		scenarioIds: ['default', 'light-two']
	},
	{
		id: 19,
		title: {
			en: 'Planning',
			de: 'Planung',
			pt: 'Planeamento'
		},
		textFront: {
			en: 'The company introduces a way of visualizing short and long term planning for staff.',
			de: 'Das Unternehmen führt eine Methode zur Veranschaulichung der kurz- und langfristigen Planung für Mitarbeiter ein.',
			pt: 'A empresa apresenta uma forma de visualizar o planeamento de curto e longo prazo para os funcionários.'
		},
		textBack: {
			en: 'This will increase staff general situational awareness, allow them to contribute and buy-in and enhance communication',
			de: 'Dies wird das allgemeine Situationsbewusstsein der Mitarbeiter erhöhen, die Kommunikation verbessern und ihnen die Möglichkeit geben, einen Beitrag zu leisten.',
			pt: 'Isso aumentará a consciência situacional geral da equipe, permitirá que contribuam e se envolvam, além de aprimorar a comunicação.'
		},
		effects: [
			{type: 'cost', value: -1},
			{type: 'time', value: -1}
		],
		scenarioIds: ['new-tasks', 'light-two']
	},
	{
		id: 20,
		title: {
			en: 'Team Meeting',
			de: 'Team Besprechung',
			pt: 'Reunião de equipa'
		},
		textFront: {
			en: 'The work shop team holds a "distraction and communication" meeting to identify active and latent safety issues and agree on best practices and behaviours to mitigate and manage these issues.',
			de: 'Das Werkstatt Team hält eine "Ablenkungs- und Kommunikationssitzung" ab, um aktive und latente Sicherheitsprobleme zu ermitteln und sich auf bewährte Praktiken und Verhaltensweisen zu einigen, um diese Probleme zu entschärfen und zu bewältigen.',
			pt: 'A equipa da oficina realiza uma reunião sobre "distração e comunicação" para identificar problemas de segurança ativos e latentes e definir as melhores práticas e comportamentos para mitigar e gerir esses problemas.'
		},
		textBack: {
			en: 'This will improve the general safety culture and allow knowledge sharing of potential problems.',
			de: 'Dies wird die allgemeine Sicherheitskultur und den Wissensaustausch von potenzielle Probleme verbessern.',
			pt: 'Isso melhorará a cultura de segurança em geral e permitirá a partilha de conhecimento sobre possíveis problemas.'
		},
		effects: [
			{type: 'risk', value: -1},
			{type: 'cost', value: -1}
		],
		scenarioIds: ['new-tasks', 'light-one']
	},
	{
		id: 21,
		title: {
			en: 'Web page',
			de: 'Internet Seite',
			pt: 'Web page'
		},
		textFront: {
			en: 'The company establish a webpage with FAQ, hint for troubleshooting, best pratices etc. Engineers and Planners are encouraged to participate with inputs.',
			de: 'Das Unternehmen richtet eine Website mit FAQ, Hinweisen zur Fehlerbehebung und bewährten Praktiken ein. Techniker und Planer sind aufgerufen, sich mit Beiträgen zu beteiligen.',
			pt: 'A empresa criou uma página na internet com perguntas frequentes, dicas para solução de problemas, melhores práticas, etc. Engenheiros e planeadores são incentivados a participar com suas contribuições.'
		},
		textBack: {
			en: 'This will give faster and better troubleshooting which will reduce downtime and costs. Employee ownership will increase.',
			de: 'Dies ermöglicht eine schnellere und bessere Fehlerbehebung, wodurch Ausfallzeiten und Kosten reduziert werden. Die Mitarbeiterbeteiligung wird zunehmen.',
			pt: 'Isso proporcionará uma resolução de problemas mais rápida e eficaz, reduzindo o tempo de inatividade e custos. O envolvimento dos funcionários na atividade da empresa aumentará.'
		},
		effects: [
			{type: 'cost', value: -1},
			{type: 'time', value: -1}
		],
		scenarioIds: ['new-tasks', 'light-two']
	},
	{
		id: 22,
		title: {
			en: 'Technical Publications',
			de: 'Technische Unterlagen',
			pt: 'Publicações técnicas'
		}, 
		textFront: {
			en: 'The availability of technical Publications in the workplace is increased by easier access by the individual worker.',
			de: 'Die Verfügbarkeit von technischen Unterlagen am Arbeitsplatz wird durch den leichteren Zugang des einzelnen Mitarbeiters erhöht.',
			pt: 'A disponibilidade de publicações técnicas no local de trabalho é ampliada pela maior facilidade de acesso por parte do trabalhador individual.'
		},
		textBack: {
			en: 'The risk of NOT consulting the manual is reduced, when the staff have easy access to needed information when and where they need it. Lack of knowledge is avoided.',
			de: 'Das Risiko, das Handbuch NICHT zu verwenden, wird verringert, indem der Zugang zu benötigten Informationen für jeden Mitarbeiter einfacher gestaltet wird. Wissensdefizite werden somit vermieden.',
			pt: 'O risco de NÃO consultar o manual é reduzido quando os funcionários têm fácil acesso às informações necessárias, quando e onde precisarem. Evita-se, assim, a falta de conhecimento.'
		},
		effects: [
			{type: 'risk', value: -1},
			{type: 'time', value: -1}
		],
		scenarioIds: ['new-tasks', 'light-one']
	}
];


export { bestPracticesData };
